module.exports = __webpack_public_path__ + "img/unknown-icon.e67770c0.jpg";